
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1440 560"}},[_c('path',{attrs:{"fill":"#FFEB99","d":"M0 21c165.604 37.552 366.27 54.885 602 52 353.594-4.328 470.162-53.413 705.243-68C1463.963-4.725 1508.216.608 1440 21v539H0V21z"}})])
      }
    
      }
    